module.exports = __webpack_public_path__ + "media/reskin-images/img--pick-path-3-a12958b6.png";